import { Model } from "@interfaces/model.interface";

export interface Skill extends Model {
	autoGenerateAndEmailCertificate: boolean;
	level1: string;
	level2: string;
	level3: string;
	level4: string;
	machineId?: number
	name: string;
	trainingLengthMonths: number;	
}

export class Skill implements Skill {
	trainingLengthMonths = 1;

	constructor(data?: Partial<Skill>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}